import { ReactNode } from 'react';

import {
  Button,
  Icons,
  Placeholder,
  HexIcon,
  Typography,
  Stack,
} from '@cast/design-system';

import { useInitializeTrialDialog } from './dialogs/useInitializeTrialDialog';

type Props = {
  name: string;
  docs?: {
    text?: string;
    link: string;
  };
  sneakPeek?: ReactNode;
};

export const TryPremiumFeature = ({ name, docs, sneakPeek }: Props) => {
  const { openDialog: openInitializeTrialDialog } = useInitializeTrialDialog();

  return (
    <Stack width="100%" alignItems="center">
      <Placeholder
        stackProps={{ mt: 32 }}
        icon={
          <HexIcon
            variant="notification"
            icon={<Icons.SelectionAll weight="fill" />}
            size={80}
          />
        }
        iconWrapperProps={{ mb: 8 }}
        title={`${name} is a premium feature`}
        titleProps={{ variant: 'h5' }}
        body={
          <Stack alignItems="center" gap={24}>
            <Stack gap={32}>
              <Stack alignItems="center" gap={16}>
                <Typography variant="P14R">
                  Try it out in our 30-day free trial.
                </Typography>

                <Button
                  endIcon={<Icons.ArrowRight />}
                  onClick={() => openInitializeTrialDialog()}
                  data-testid="cta-button"
                >
                  Try it now for free
                </Button>
              </Stack>

              {docs && (
                <Button
                  size="lg"
                  variant="text"
                  startIcon={<Icons.Book />}
                  component="a"
                  href={docs.link}
                  rel="noopener noreferrer"
                  target="_blank"
                  data-testid="docs-button"
                >
                  {docs.text ? docs.text : `${name} documentation`}
                </Button>
              )}
            </Stack>
            {sneakPeek}
          </Stack>
        }
        bodyProps={{ mt: '4px', component: 'div' }}
        testId="paywall-page"
      />
    </Stack>
  );
};
